import { cn } from "@/utils/cn"
import type { BasicListItemProps } from "./BasicListItem.types"

type BasicListItemStyleProps = Pick<BasicListItemProps, "customContent" | "color">

export const getBasicListItemStyles = ({ customContent, color }: BasicListItemStyleProps) => {
  return {
    wrapper: cn(
      "flex h-full min-w-[200px] items-center justify-between gap-[8px] rounded-[8px] bg-gradient-to-r from-dark-500 from-[50%] to-dark-100/20 p-4",
      "transition-all duration-300",
      {
        "p-2": customContent,
        "to-success/20": color === "success",
        "to-warning/20": color === "warning",
        "to-error/20": color === "error",
        "to-info/20": color === "info",
        "to-primary/20": color === "primary",
      }
    ),
    textWrapper: cn("flex min-w-0 flex-grow flex-col text-dark-100", {}),
    actionWrapper: "ml-4 flex-shrink-0",
  }
}
